import { push } from 'connected-react-router'
import { getTeamUrl } from 'Common'

export default () => async (dispatch) => {

  dispatch(push(getTeamUrl('estimates/caveats')))
  
}